import React, { useContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";

import css from "./AdminPage.module.css";
import Head from "../../utils/Head";
import { newId } from "../../utils/newId";
import { Input } from "../../components/common/Input";
import { InputArea } from "../../components/common/InputArea";
import { DataContext } from "../../context/DataContext";
import { storage } from "../../services/firebaseConfig";
import { createActsListFirebase } from "../../services/firebaseService";
import dayjs from "dayjs";

export const EditAct = () => {
  const {
    mindList,
    setMindList,
    moveList,
    setMoveList,
    nutriList,
    setNutriList,
    valuesList,
    setValuesList,
  } = useContext(DataContext);
  const { state } = useLocation();
  const navigate = useNavigate();
  const [date, setDate] = useState("");
  const [axis, setAxis] = useState("");
  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");
  const [content, setContent] = useState("");
  const [image, setImage] = useState("");
  const [imageUpload, setImageUpload] = React.useState(null);
  const [audio, setAudio] = useState("");
  const [audioUpload, setAudioUpload] = React.useState(null);
  const [progress, setProgress] = React.useState(null);

  useEffect(() => {
    if (state) {
      setDate(state.date);
      setAxis(state.axis);
      setTitle(state.title);
      setUrl(state.url);
      setImage(state.image);
      setContent(state.content);
    }
  }, [state]);

  function handleSubmit() {
    let updatedPostList = [];

    const updatedPost = {
      id: state.id,
      createdAt: state.createdAt,
      updatedAt: Date.now(),
      axis: axis,
      title: title,
      url: url,
      image: image,
      content: content,
    };

    if (axis === "mind") {
      updatedPostList = [...mindList];
      updatedPostList = updatedPostList.map((post) =>
        post.id === updatedPost.id ? updatedPost : post
      );
      setMindList(updatedPostList);
      createActsListFirebase("mind", updatedPostList);
    } else if (axis === "move") {
      updatedPostList = [...moveList];
      updatedPostList = updatedPostList.map((post) =>
        post.id === updatedPost.id ? updatedPost : post
      );
      setMoveList(updatedPostList);
      createActsListFirebase("move", updatedPostList);
    } else if (axis === "nutri") {
      updatedPostList = [...nutriList];
      updatedPostList = updatedPostList.map((post) =>
        post.id === updatedPost.id ? updatedPost : post
      );
      setNutriList(updatedPostList);
      createActsListFirebase("nutri", updatedPostList);
    } else if (axis === "family" || "career" || "fun") {
      updatedPostList = [...valuesList];
      updatedPostList = updatedPostList.map((post) =>
        post.id === updatedPost.id ? updatedPost : post
      );
      setValuesList(updatedPostList);
      createActsListFirebase("values", updatedPostList);
    }

    alert("post updated");
    navigate("/admin");
  }

  const uploadImage = () => {
    const name = newId();
    let imageRef = ref(storage, `postImages/${state.axis}/${name}`);

    const uploadTask = uploadBytesResumable(imageRef, imageUpload);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(progress);
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
          default:
            break;
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          console.log(downloadURL);
          setImage(downloadURL);
          alert("Image Uploaded");
        });
      }
    );
  };

  const uploadAudio = () => {
    const name = newId();
    let audioRef = ref(storage, `postAudios/${state.axis}/${name}`);

    const uploadTask = uploadBytesResumable(audioRef, audioUpload);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(progress);
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
          default:
            break;
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          console.log(downloadURL);
          setAudio(downloadURL);
          alert("Audio Uploaded");
        });
      }
    );
  };

  return (
    <div className={css.container}>
      <h4>Edit Post</h4>
      <p>Date: {dayjs().format("DD/MM/YY")}</p>
      <p>axis: {axis}</p>
      <div>
        <label className={css.axis}>
          mind
          <input
            type="checkbox"
            checked={axis === "mind" ? true : false}
            onChange={() => {
              setAxis("mind");
            }}
          />
          <span className={css.checkmark}></span>
        </label>
        <label className={css.axis}>
          move
          <input
            type="checkbox"
            checked={axis === "move" ? true : false}
            onChange={() => {
              setAxis("move");
            }}
          />
          <span className={css.checkmark}></span>
        </label>
        <label className={css.axis}>
          nutri
          <input
            type="checkbox"
            checked={axis === "nutri" ? true : false}
            onChange={() => {
              setAxis("nutri");
            }}
          />
          <span className={css.checkmark}></span>
        </label>
        <label className={css.axis}>
          family
          <input
            type="checkbox"
            checked={axis === "family" ? true : false}
            onChange={() => setAxis("family")}
          />
          <span className={css.checkmark}></span>
        </label>
        <label className={css.axis}>
          career
          <input
            type="checkbox"
            checked={axis === "career" ? true : false}
            onChange={() => setAxis("career")}
          />
          <span className={css.checkmark}></span>
        </label>
        <label className={css.axis}>
          fun
          <input
            type="checkbox"
            checked={axis === "fun" ? true : false}
            onChange={() => setAxis("fun")}
          />
          <span className={css.checkmark}></span>
        </label>
      </div>
      <Input
        type="text"
        name="title"
        placeholder="Title"
        label="Title"
        value={title}
        required
        className={css.inputText}
        onChange={(e) => setTitle(e.target.value)}
        autoComplete="off"
      />
      <Input
        type="text"
        name="url"
        placeholder="url"
        label="url"
        value={url}
        required
        className={css.inputText}
        onChange={(e) => setUrl(e.target.value)}
        autoComplete="off"
      />
      {image && <img alt="" src={image} className={css.image} />}
      <div>
        <input
          type="file"
          onChange={(event) => {
            setImageUpload(event.target.files[0]);
          }}
        />
        <button
          onClick={(e) => {
            e.preventDefault();
            uploadImage();
          }}
          disabled={progress !== null && progress < 100}
        >
          Upload Image
        </button>
      </div>
      {audio && <img alt="" src={audio} className={css.audio} />}
      <div>
        <input
          type="file"
          onChange={(event) => {
            setAudioUpload(event.target.files[0]);
          }}
        />
        <button
          onClick={(e) => {
            e.preventDefault();
            uploadAudio();
          }}
          disabled={progress !== null && progress < 100}
        >
          Upload Audio
        </button>
      </div>
      <InputArea
        type="text"
        name="content"
        placeholder="Content"
        label="Content"
        value={content}
        required
        className={css.inputText}
        onChange={(e) => setContent(e.target.value)}
        autoComplete="off"
      />
      <div className={css.footer} onClick={() => handleSubmit()}>
        <button className="saveButton">Save</button>
      </div>
    </div>
  );
};
